import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormError from "../../../gd-form/common/form-error/form-error"
import FieldFormElement from "../../../fields3/render/form-elemnent"

type Props = {
    form: FormManager
}

export default function CustomFieldIntegersOnly(props: Props) {

    const field = gd.fields.customFieldParams.integersOnly

    return (
        <FormRowFlex field={field}>
            <FieldFormElement field = {field}
                              form  = {props.form}/>
            <FormError form = {props.form}
                       name = {field.fieldId} />
        </FormRowFlex>
    )
}